/** Mirrors services/api/src/teacher-billing.ts — keep in sync for marketing and in-app copy. */
export const TEACHER_APP_TRIAL_DAYS = 15;
export const TEACHER_TRIAL_COHORT_LIMIT = 2;
export const TEACHER_TRIAL_STUDENTS_PER_COHORT = 15;
export const TEACHER_TRIAL_MAX_STUDENTS = TEACHER_TRIAL_COHORT_LIMIT * TEACHER_TRIAL_STUDENTS_PER_COHORT;
export const TEACHER_TRIAL_LESSON_LIMIT = 5;
export const TEACHER_TRIAL_AI_REQUESTS = 10;
export const TEACHER_PAID_COHORT_LIMIT = 6;
export const TEACHER_PAID_STUDENTS_PER_COHORT = 40;
export const TEACHER_PAID_MAX_STUDENTS = TEACHER_PAID_COHORT_LIMIT * TEACHER_PAID_STUDENTS_PER_COHORT;
export const TEACHER_PAID_AI_REQUESTS_PER_MONTH = 500;

export const TEACHER_TRIAL_LIMITS_LINE = `${TEACHER_TRIAL_COHORT_LIMIT} active cohorts (up to ${TEACHER_TRIAL_STUDENTS_PER_COHORT} students each, ${TEACHER_TRIAL_MAX_STUDENTS} total), ${TEACHER_TRIAL_LESSON_LIMIT} lessons in your library, and ${TEACHER_TRIAL_AI_REQUESTS} AI requests for the trial period`;

export const TEACHER_TRIAL_SUMMARY = `${TEACHER_APP_TRIAL_DAYS}-day free trial (no card required): ${TEACHER_TRIAL_LIMITS_LINE}.`;

export const TEACHER_PAID_LIMITS_LINE = `${TEACHER_PAID_COHORT_LIMIT} active cohorts (unlimited concluded cohorts, up to ${TEACHER_PAID_STUDENTS_PER_COHORT} students each, ${TEACHER_PAID_MAX_STUDENTS} total)`;

export const TEACHER_PAID_FEATURES_LINE = `Unlimited lessons, ${TEACHER_PAID_LIMITS_LINE}, and ${TEACHER_PAID_AI_REQUESTS_PER_MONTH} AI requests per month`;

export const TEACHER_TRIAL_VS_STRIPE_NOTE =
  "The free trial starts when you sign in as a teacher. No payment method is required. Subscribe through Stripe to raise your limits; checkout starts your paid plan right away.";
